import script from "./ChangeProjectPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeProjectPopover.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeProjectPopover.vue?vue&type=style&index=0&id=ef5ce89c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef5ce89c"]])

export default __exports__